import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TooltipModule } from 'ng2-tooltip-directive';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';

import { UgovoriComponent } from './ugovori.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    TooltipModule,
    NgxSpinnerModule,
  ],
  declarations: [UgovoriComponent],
  entryComponents: [UgovoriComponent],
  exports: [UgovoriComponent],
})
export class UgovoriModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ugovori/ugovori.module.ts